import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  Collapse,
  Drawer as MuiDrawer,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

export const estatedItems = [
  {
    name: "Summary",
    items: [{ key: "summary", label: "Summary" }],
  },
  {
    name: "Flood Map",
    items: [{ key: "flood_map", label: "Flood Map" }],
  },
  {
    name: "Detail",
    items: [
      { key: "address", label: "Address" },
      { key: "assessments", label: "Assessments" },
      { key: "deeds", label: "Deeds" },
      { key: "market_assessments", label: "Market Assessments" },
      { key: "metadata", label: "Metadata" },
      { key: "mortgages", label: "Mortgages" },
      { key: "other_areas", label: "Other Areas" },
      { key: "other_features", label: "Other Features" },
      { key: "other_improvements", label: "Other Improvements" },
      { key: "owners", label: "Owners" },
      { key: "parcels", label: "Parcels" },
      { key: "structures", label: "Structures" },
      { key: "taxes", label: "Taxes" },
      { key: "valuations", label: "Valuations" },
    ],
  },
];

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

export default function Drawer(props) {
  const [open, setOpen] = useState(
    props.selectedItem.key !== "summary" ? "Detail" : null
  );
  const [searchParams] = useSearchParams();
  const buildMenuOption = (item, index) => {
    return (
      <StyledLink
        to={{ pathname: item.key, search: searchParams.toString() }}
        key={index}
      >
        <ListItemButton selected={props.selectedItem.key === item.key}>
          <ListItemText primary={item.label} />
        </ListItemButton>
      </StyledLink>
    );
  };
  const buildCollapseMenuOption = (group, index) => {
    const handleClick = () => {
      setOpen(group.name === open ? null : group.name);
    };
    return (
      <div key={index}>
        <ListItemButton onClick={handleClick}>
          <ListItemText primary={group.name} />
          {open === group.name ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={open === group.name} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {group.items.map((item) => {
              return (
                <StyledLink
                  to={{ pathname: item.key, search: searchParams.toString() }}
                  key={item.key}
                >
                  <ListItemButton
                    selected={props.selectedItem.key === item.key}
                  >
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                </StyledLink>
              );
            })}
          </List>
        </Collapse>
      </div>
    );
  };
  const bgcolor = "rgba(113, 63, 250, 0.2)";
  return (
    <MuiDrawer
      sx={{
        width: 240,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: 240,
          boxSizing: "border-box",
        },
      }}
      variant="persistent"
      anchor="left"
      open={props.open}
    >
      <Toolbar></Toolbar>
      <List
        component="nav"
        sx={{
          "&& .Mui-selected, && .Mui-selected:hover": { bgcolor },
          "& .MuiListItemButton-root:hover": { bgcolor },
        }}
      >
        {estatedItems.map((group, index) => {
          const isCollapse = group.items.length > 1;
          if (isCollapse) {
            return buildCollapseMenuOption(group, index);
          }
          return buildMenuOption(group.items[0], index);
        })}
      </List>
    </MuiDrawer>
  );
}
